import { useTranslation } from 'react-i18next';

import { Banner, Flex, Text } from '@electricjs/arc';

type NoWorkEmailBannerProps = {
  employeeName: string;
};

export const NoWorkEmailBanner = ({ employeeName }: NoWorkEmailBannerProps) => {
  const { t } = useTranslation('common');

  return (
    <Flex width="100%" justifyContent="center">
      <Banner
        id="no-work-email-banner"
        isFlat
        intent="error"
        title={t('onboardings.noWorkEmailBanner.title')}
        message={() => (
          <>
            <Text variant="body-2">
              {t('onboardings.noWorkEmailBanner.message', { employeeName })}
              <br />
              {t('onboardings.noWorkEmailBanner.hrisIntegrationMessage')}
            </Text>
          </>
        )}
      />
    </Flex>
  );
};
